const CollapsiblePanelComponent = require("./collapsible-panel.component");

const CollapsiblePanelsService = function () {
    let $currentContext = $();

    var panelsList = [];

    function checkAnchor() {
        const anchor = window.top.location.hash.slice(1);
        if (anchor) {
            const targetPanel = panelsList.find(panel => panel.hasAnchoredElement(anchor));
            if (targetPanel) {
                targetPanel.showAnchoredElement(anchor);
            }
        }
    }

    function bindEvents() {
        $(window).on("hashchange", function () {
            checkAnchor();
        });
    }

    function parseContext() {
        var $panels = $(CollapsiblePanelComponent.SELECTOR, $currentContext);

        $panels.each((index, entry) => {
            var $panelContext = $(entry);
            var panel = new CollapsiblePanelComponent();
            panel.init($panelContext);
            panelsList.push(panel);
        });
    }

    this.init = function ($context) {
        $currentContext = $context || $currentContext;

        parseContext();
        bindEvents();
        checkAnchor();
    };

    return this;
};

module.exports = CollapsiblePanelsService;
